<template>
  <div style="height: 100%; ">
    <div class="grid-x align-middle">
      <div class="small-1 cell">
        <rare-back-icon
          class="backIcon"
          :tabIndex="1"
          @clicked="backToMainSite" />
      </div>
      <div class="cell small-10 text-center">
        <img src="@/assets/img/logos/rare-news.png" class="header-logo" alt="Rare News logo" />
      </div>
      <div class="small-1 cell">
        &nbsp;&nbsp;
      </div>

    </div>

    <div class="grid-x grid-padding-x align-middle contentContainer">
      <div class="small-2 cell">
        &nbsp;&nbsp;
      </div>
      <div class="cell small-8 contentPosition text-left">
        <router-link tabindex="2"
             @keypress.native="navigate('/news/oxford-and-Cambridge-to-work-with-rare-on-target-oxbridge-year-10-programme')"
             tag="h1"
             to="/news/oxford-and-Cambridge-to-work-with-rare-on-target-oxbridge-year-10-programme">
          Oxford and Cambridge to work with Rare on Target Oxbridge Year 10 programme
        </router-link>
        <div class="dash news-dash">&nbsp;</div>
        <p><strong>News</strong> 9th February 2023</p>
      </div>
      <div class="small-2 cell">
        &nbsp;&nbsp;
      </div>
    </div>
  </div>
</template>

<script>

import RareBackIcon from 'rare-patternlab/icons/navigation/RareBackIconBlack';

export default {
  name: 'RareStoriesHeaderContents',
  components: {
    'rare-back-icon': RareBackIcon,
  },
  methods: {
    backToMainSite() {
      let backToPath = this.$store.getters.backTo;
      if (backToPath === '') {
        backToPath = '/';
      }
      this.$store.commit('updateScrollToBottom', true);
      this.$router.push(this.$store.getters.backTo);
    },
    navigate(path) {
      this.$store.state.newsYPos = window.scrollY;
      this.$router.push({ path });
    },

  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .contentContainer {
    height: 100%;
  }

  h1 {
    color: $main-text;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    text-align: left;
    cursor: pointer;
  }

  h1:hover {
    text-decoration: underline;
  }

  p {
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    text-align: left;
  }

  p strong {
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    text-align: left;
  }

  .news-dash {
    background-color: $news;
  }
  .awards-dash {
    background-color: $awards;
  }
  .press-dash {
    background-color: $press;
  }

  @media only screen and (max-width: 640px)  {

    .contentPosition {
      margin-top: -50px;
    }


    .backIcon {
      margin-left: 24px;
      margin-top: 24px;
    }

    .header-logo {
      height: 16px;
      margin-top: 24px;
    }

    .dash {
      display: inline-block;
      width: 40px;
      height: 4px;
      padding: 0;
      margin: 10px 0 10px 0;
      line-height: 4px;
    }

    h1 {
      font-size: 32px;
      line-height: 1.25;
      letter-spacing: 0.4px;
    }

    p {
      font-size: 14px;
      font-weight: 300;
      line-height: 1.71;
      letter-spacing: 0.2px;
    }

    p strong {
      font-size: 14px;
      line-height: 1.71;
      letter-spacing: 0.2px;
    }

  }

  @media only screen and (min-width: 641px)  {

    .header-logo {
      height: 30px;
      margin-top: 40px;
    }

    .backIcon {
      margin-left: 24px;
    }

    .contentPosition {
      margin-top: -50px;
    }

    .dash {
      display: inline-block;
      width: 80px;
      height: 8;
      padding: 0;
      margin: 35px 0 24px 0;
      line-height: 8px;
    }

    h1 {
      font-size: 56px;
      line-height: 1.29;
      letter-spacing: 0.8px;
    }

    p {
      font-size: 21px;
      line-height: 1.52;
      letter-spacing: 0.4px;
    }

    p strong {
      font-size: 24px;
      line-height: 1.5;
      letter-spacing: 0.5px;
    }

  }


</style>



// WEBPACK FOOTER //
// src/pages/news/components/RareNewsHeaderContents.vue